import { computed } from 'vue'

import { Stat, StatId } from '@collector/sportsapi-client-legacy'

import { useParticipants } from './useParticipants'

type StatsMap = Record<StatId, Stat>

const toStatsMap = (stats: Stat[] | undefined): StatsMap =>
  Object.fromEntries((stats ?? []).map((s) => [s.id, s])) as StatsMap

export const useParticipantStatsMaps = () => {
  const { homeParticipant, awayParticipant } = useParticipants()

  return {
    homeParticipantStatsMap: computed(() =>
      toStatsMap(homeParticipant.value?.stats),
    ),
    awayParticipantStatsMap: computed(() =>
      toStatsMap(awayParticipant.value?.stats),
    ),
  }
}
